import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "@/views/landing.vue";
import Disclaimer from "@/views/disclaimer.vue";
import RateUs from "@/views/rate_us.vue";
import RatingSuccess from "@/views/rating_success.vue";
import EmailSuccess from "@/views/email_success.vue";
import PageNotFound from "@/views/page_not_found.vue";

import QuestionRoutes from "./modules/question.route";
import InfoRoutes from "./modules/info.route";
import SummaryRoutes from "./modules/summary.route";
import FinalSummaryRoutes from "./modules/final_summary.route";
import FormRoutes from "./modules/form.route";

Vue.use(VueRouter);

const MainRoutes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/rating_success",
    name: "RatingSuccess",
    component: RatingSuccess,
  },
  {
    path: "/disclaimer",
    name: "Disclaimer",
    component: Disclaimer,
  },
  {
    path: "/rate_us",
    name: "RateUs",
    component: RateUs,
    props: true,
  },
  {
    path: "/email_success",
    name: "EmailSuccess",
    component: EmailSuccess,
    props: true,
  },
  { path: "*", component: PageNotFound },
];

var allRoutes = [];
allRoutes = allRoutes.concat(
  MainRoutes,
  InfoRoutes,
  SummaryRoutes,
  FormRoutes,
  QuestionRoutes,
  FinalSummaryRoutes
);

const routes = allRoutes;

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
